import { render, staticRenderFns } from "./InvoiceSalesRed.vue?vue&type=template&id=eb224b3a&scoped=true"
import script from "./InvoiceSalesRed.vue?vue&type=script&lang=js"
export * from "./InvoiceSalesRed.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSalesRed.vue?vue&type=style&index=0&id=eb224b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb224b3a",
  null
  
)

export default component.exports